import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-widgets/dist/css/react-widgets.css";
import parseAPIErrorFormik from "utils/parseAPIErrorFormik";

toast.configure({ autoClose: 10000, position: toast.POSITION.BOTTOM_RIGHT });

const successToast = (message, options = {}) =>
  toast(message, {
    className: "alert alert-success fade show",
    progressClassName: "progress-bar bg-success",
    ...options,
  });

const errorToast = (message, options = {}) =>
  toast(message, {
    className: "alert alert-danger fade show",
    progressClassName: "progress-bar bg-danger",
    ...options,
  });

const apiErrorToast = (
  error,
  defaultMessage,
  mappings = {},
  isSingleItem = false,
  customMapperFn
) => {
  const parsedError = parseAPIErrorFormik(
    error,
    mappings,
    isSingleItem,
    customMapperFn
  );
  const errorKeys = Object.keys(parsedError);
  errorKeys.forEach((k) => errorToast(parsedError[k]));
  if (!errorKeys.length) {
    errorToast(error.response?.data?.message || defaultMessage);
    return null;
  }
  return parsedError;
};

export { errorToast, successToast, apiErrorToast };
